import React from "react";
import Data from '../../Data';
import Button from '../Utility/Button';
import Input from '../Utility/Input';

class ContactForm extends React.Component {

  render() {
    return (
		<form action={Data.contact.formspree} method="POST">
			<Input autocomplete="off" label="Nombre" />
			<Input autocomplete="off" label="Correo electrónico" />
			<Input autocomplete="off" label="Mensaje" textArea />
			<Button
				right
				submit
				text="Enviar mensaje"
			/>
      	</form>
    );
  }
}

export default ContactForm;
